if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.search = this.querySelector('.localization-form__search-input');

        this.onBodyClick = this.onBodyClick.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);

        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        // Needed now that focus can move into the search input; close when focus leaves the component
        this.addEventListener('focusout', this.onFocusOut);

        this.addEventListener('click', (event) => {
          const item = event.target.closest('a[data-value]');
          if (item && this.contains(item)) this.onItemClick(event, item);
        });

        if (this.search) {
          this.search.addEventListener('input', this.onSearchInput.bind(this));
          this.search.addEventListener('keydown', (event) => {
            if (event.code?.toUpperCase() === 'ESCAPE') {
              event.preventDefault();
              this.search.value = '';
              this.onSearchInput();
              this.hidePanel();
              this.elements.button.focus();
            }
          });
        }
      }

      get listItems() {
        return Array.from(this.querySelectorAll('.disclosure__item'));
      }

      hydrateList() {
        const list = this.querySelector('[data-list-source]');
        if (!list || list.children.length) return;
        const source = document.getElementById(list.dataset.listSource);
        if (source) list.innerHTML = source.innerHTML;
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        document.removeEventListener('click', this.onBodyClick);
      }

      onBodyClick(event) {
        if (this.contains(event.target)) return;
        this.hidePanel();
      }

      onFocusOut(event) {
        const next = event.relatedTarget;
        if (next && this.contains(next)) return;
        this.hidePanel();
      }

      onSearchInput() {
        if (!this.search) return;
        const query = this.search.value.trim().toLowerCase();
        this.listItems.forEach((li) => {
          const text = li.textContent ? li.textContent.toLowerCase() : '';
          li.hidden = query.length > 0 && !text.includes(query);
        });
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event, item) {
        event.preventDefault();
        const form = this.querySelector('form');
        const value = item.dataset.value;
        this.elements.input.value = value;

        if (this.elements.input.name === 'locale_code') {
          const languageCodeInput = this.querySelector('input[name="language_code"]');
          if (languageCodeInput) languageCodeInput.value = value;
        }

        if (form) {
          this.prepareFormForSubmit(form);
          form.submit();
        }
      }

      prepareFormForSubmit(form) {
        if (!form.querySelector('input[name="_method"]')) {
          const methodInput = document.createElement('input');
          methodInput.type = 'hidden';
          methodInput.name = '_method';
          methodInput.value = 'PUT';
          form.appendChild(methodInput);
        }

        let returnInput = form.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          form.appendChild(returnInput);
        }

        returnInput.value = this.getReturnPath();

        if (this.isLocalThemeDev() && window.Shopify.shop) {
          form.action = `https://${window.Shopify.shop}/localization`;
        }
      }

      getReturnPath() {
        const path = `${window.location.pathname}${window.location.search}`;

        if (!this.isLocalThemeDev() || !window.Shopify?.theme?.id) return path;

        const returnUrl = new URL(path, window.location.origin);
        returnUrl.searchParams.set('preview_theme_id', window.Shopify.theme.id);

        return `${returnUrl.pathname}${returnUrl.search}`;
      }

      isLocalThemeDev() {
        return window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
      }

      openSelector() {
        this.hydrateList();
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );

        // Reset filter on open and focus search for fast switching
        if (!this.elements.panel.hasAttribute('hidden') && this.search) {
          document.addEventListener('click', this.onBodyClick);
          this.search.value = '';
          this.onSearchInput();
          this.search.focus();
        } else {
          document.removeEventListener('click', this.onBodyClick);
        }
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
